module.exports = __webpack_public_path__ + "img/quest_visualization_quest_pending_6.41fc92fb.svg";